import {Action, di} from "@dp-instant/core";
import {injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {View} from "@dp-instant/2d";

@injectable()
export class DestroyFieldAction extends Action {
    async execute(): Promise<any> {
        if (di.isBound(TypesGame.views.fieldInstance)) {
            const fieldViewInstance = di.get<View>(TypesGame.views.fieldInstance);
            fieldViewInstance?.parent.removeChild(fieldViewInstance);
            di.unbind(TypesGame.views.fieldInstance);
        }
    }
}
